export var CancellationContractType;
(function (CancellationContractType) {
    CancellationContractType["TRADEVEST_SECURITIES"] = "tradevest_securities";
})(CancellationContractType || (CancellationContractType = {}));
export const TRADEVEST_CANCELLATION_STATUSES = [
    'not_started',
    'declared',
    'manual_review',
    'submitted',
    'pending',
    'completed',
    'rejected',
];
//# sourceMappingURL=cancellation.types.js.map